import { SectionHeader } from './shared'
import type { TreeProps } from './shared'

export function SpecsTree({ tree, search, expandedSections, toggleSection }: TreeProps) {
  return (
    <div>
      <div className="grid grid-cols-[1fr_60px] px-4 py-1.5 bg-warm-100 border-b border-border text-[10px] font-semibold text-text-muted uppercase tracking-wider">
        <div>Spec</div>
        <div>Tests</div>
      </div>

      <SectionHeader num={1} title="Feature Specs" count={tree.capabilities.reduce((s, c) => s + c.features.length, 0)} isOpen={expandedSections.has('s-0') || expandedSections.size === 0} onToggle={() => toggleSection('s-0')} />
      {(expandedSections.has('s-0') || expandedSections.size === 0) && tree.capabilities.map(({ capability, features }) => (
        <div key={capability.id}>
          <div className="px-4 py-2 pl-8 bg-warm-50/50 border-b border-border-subtle font-semibold text-[13px]">{capability.name}</div>
          {features.filter(f => !search || f.name.toLowerCase().includes(search.toLowerCase())).map((f) => (
            <div key={f.id} className="grid grid-cols-[1fr_60px] px-4 py-2.5 pl-10 border-b border-border-subtle items-center hover:bg-warm-50 transition-colors">
              <div>
                <div className="text-[13.5px] font-medium">{f.name}</div>
                {f.specsDescription && <div className="text-[12px] text-text-muted font-mono mt-0.5">{f.specsDescription}</div>}
              </div>
              <div>
                {f.acceptanceCriteria.length > 0 && (
                  <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-warm-200 text-text-muted">{f.acceptanceCriteria.length} tests</span>
                )}
              </div>
            </div>
          ))}
        </div>
      ))}

      <SectionHeader num={2} title="Architecture Decisions" isOpen={expandedSections.has('s-1')} onToggle={() => toggleSection('s-1')} />
      {expandedSections.has('s-1') && (
        <div className="px-4 py-3 pl-8 text-sm text-text-muted border-b border-border-subtle italic">
          Architecture decisions will be auto-populated from ADR documents
        </div>
      )}

      <SectionHeader num={3} title="Graph Traceability" isOpen={expandedSections.has('s-2')} onToggle={() => toggleSection('s-2')} />
      {expandedSections.has('s-2') && (
        <div className="px-4 py-3 pl-8 text-sm text-text-secondary border-b border-border-subtle">
          <span className="font-mono text-[12px]">Spec → FR → Feature → Capability → Pain → Interview Evidence</span>
        </div>
      )}
    </div>
  )
}
